/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CheckPointsInputAsJSON } from './CheckPointsInputAsJSON';
import { CodeQualityInputAsJSON } from './CodeQualityInputAsJSON';
import { CustomOutputInputAsJSON } from './CustomOutputInputAsJSON';
import { IOTestInputAsJSON } from './IOTestInputAsJSON';
import { JunitTestInputAsJSON } from './JunitTestInputAsJSON';
import { RunProgramInputAsJSON } from './RunProgramInputAsJSON';
const UpdateSuiteAutoTestBaseDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'steps',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['io_test', IOTestInputAsJSON],
            ['run_program', RunProgramInputAsJSON],
            ['custom_output', CustomOutputInputAsJSON],
            ['check_points', CheckPointsInputAsJSON],
            ['junit_test', JunitTestInputAsJSON],
            ['code_quality', CodeQualityInputAsJSON],
        ]))),
    ],
    ['rubricRowId', codecNumber, 'rubric_row_id'],
    ['networkDisabled', codecBoolean, 'network_disabled'],
]);
export class UpdateSuiteAutoTestBaseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UpdateSuiteAutoTestBaseDataParser.decode(input).map(res => new UpdateSuiteAutoTestBaseData(res));
    }
    static unsafeDecode(input) {
        return UpdateSuiteAutoTestBaseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpdateSuiteAutoTestBaseDataParser.encode(data);
    }
    static schema() {
        return UpdateSuiteAutoTestBaseDataParser.schema();
    }
}
